import { useDispatch, useSelector } from 'react-redux';
import { Outlet } from 'react-router-dom';
import { MySnackBar } from '../Components/MySnackbar';
import { theme } from '../Mui/Theme';
import { RootState } from '../Store';
import { closeAlert } from '../Store/AlertSlice';
import { MainNavigation } from './MainNavigation';

export const MainLayout: React.FC = () => {
    const snackbarState = useSelector((state: RootState) => state.alertSlice);
    const dispatch = useDispatch();

    return (
        <div
            style={{
                height: '100vh',
                overflow: 'hidden',
            }}
        >
            <div style={{ height: '10vh' }}>
                <MainNavigation />
            </div>
            <div
                style={{
                    height: '90%',
                    background: theme.palette.primary.light,
                    overflowY: 'auto',
                    overflowX: 'auto',
                }}
            >
                <Outlet />
            </div>
            <MySnackBar
                open={snackbarState.show}
                text={snackbarState.text}
                severity={snackbarState.severity}
                onClose={() => dispatch(closeAlert())}
            />
        </div>
    );
};
